import { useState } from "react";
import { Button, ButtonVariant, ButtonSize } from "shared/components";
import { DiscountTag02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { ActiveDiscountsModal } from "views/discounts/components/ActiveDiscountsModal";
import { useDiscounts } from "views/discounts/hooks/useDiscounts";

export const ViewDiscountCodesButton = ({
  templateId
}: {
  templateId: string;
}) => {
  const [showActiveDiscountsModal, setShowActiveDiscountsModal] =
    useState(false);
  const { data: discountCodes = [] } = useDiscounts({
    active: true,
    restriction_type: "template",
    template_id: templateId,
    enabled: !!templateId
  });

  if (!discountCodes.length) return null;

  return (
    <>
      <Button
        borderLess
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        HugeIcon={DiscountTag02Icon}
        className="!text-content-400 !stroke-content-400"
        onClick={() => setShowActiveDiscountsModal(true)}
      >
        Discount codes
      </Button>

      <ActiveDiscountsModal
        isOpen={showActiveDiscountsModal}
        onClose={() => setShowActiveDiscountsModal(false)}
        discounts={discountCodes}
      />
    </>
  );
};
